<template>
  <input-group title="境界立会申請">
    <p>ご指定の境界立会の仮登録情報が見つかりませんでした。</p>
    <p>以下をご確認ください。</p>
    <br />
    <p>・既に本登録が完了している場合、以前の仮登録情報はご利用いただけません。</p>
    <p>・仮登録から{{ TMP_APPLY_EXPIRES }}時間経過している仮登録情報はご利用いただけません。</p>
  </input-group>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import InputGroup from '@/components/layout/InputGroup.vue'
import { TMP_APPLY_EXPIRES } from '@/constants/backendConstants'

/**
 * 境界立会申請 エラー画面
 */
export default defineComponent({
  name: 'BoundaryAuthError',
  components: {
    InputGroup,
  },
  setup() {
    return {
      TMP_APPLY_EXPIRES,
    }
  },
})
</script>
